<script>

import HeaderSection from "../package/HeaderSection.vue";
import DrawerAside from "../package/DrawerAside.vue";
import FooterSection from "../package/footerSection.vue";

export default {
  name: "advertiseWithUsLayout",
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  components: {FooterSection, DrawerAside, HeaderSection},
  methods: {
    fold() {
      this.unfold = false;
    },
    spread() {
      this.unfold = true;
    }
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
}
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)"/>
    </el-aside>
    <el-container>
      <header-section @spread="spread"/>
      <el-main>
        <!--      new design-->
        <div class="landing-page">
          <el-row>
            <el-col :span="24">

              <img src="../../assets/advertise-with-us-banner.png" alt="img"
                   style="width: 100%; height: 100%; object-fit: cover">

            </el-col>

          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <div class="title-txt-wrapper">
                Welcome to an exclusive platform designed for brands, service providers, and businesses in the property market looking to reach an
                active audience of homebuyers and investors interested in new developments and off-the-plan properties. By advertising with us, your
                business will be placed in front of highly engaged buyers, ready to explore, invest, and purchase. With prominent ad placements,
                insightful data, and tailored campaigns, we help you amplify your brand’s reach directly within the real estate journey.
              </div>
            </el-col>
          </el-row>
          <!-- Benefits Section -->
          <el-row class="benefits-section">
            <el-col :xs="24" :sm="12">
              <h2>U-Promote: Benefits of Advertising with Us</h2>
              <ul class="benefits-list">
                <li>
                  <h3>Targeted Audience</h3>
                  <p>Reach buyers actively searching for new and off-the-plan properties, from first-time buyers to
                    investors.</p>
                </li>
                <li>
                  <h3>High Visibility</h3>
                  <p>Take advantage of prominent ad placements across our platform for maximum exposure.</p>
                </li>
                <li>
                  <h3>Engaged Audience</h3>
                  <p>Access a highly engaged audience.
                    With the amount of information agents showcase on
                    each property, users spend substantial time viewing our
                    property platform.</p>
                </li>
              </ul>
            </el-col>
            <el-col :xs="24" :sm="12" class="benefits-image-container">
              <div class="benefits-image-wrapper">
                <img src="../../assets/advertise-mobile-image.png" alt="Mobile app demonstration" class="benefits-image">
              </div>
            </el-col>
          </el-row>

          <!-- Features Section -->
          <div class="features-section">
            <h2>Agents:Showcase Your Properties to a Ready Market</h2>
            <p class="features-intro">
              As an agent, you know that off-the-plan and new property sales require clear, detailed listings to attract the right buyers. Our platform is
              built for properties like yours, catering to those looking for off the plan properties and new homes, custom options, and efficient layouts.
              Listing with us puts your properties in front of a targeted audience, ready to reserve and explore off-the-plan opportunities.
            </p>

            <el-row :gutter="40">
              <el-col :span="12" class="feature-image-container">
                <div class="feature-image-wrapper">
                <img src="../../assets/advertise-laptop-image.png" alt="Platform demonstration" class="feature-image">
                </div>
              </el-col>
              <el-col :span="12">
                <div class="feature-list">
                  <h2>Why List with Us?</h2>
                  <ul>
                    <li>
                      <h3>Detailed, Interactive Listings</h3>
                      <p>Showcase floor plans, live pricing,
                        and features buyers need to make informed decisions</p>
                    </li>
                    <li>
                      <h3>Online Reservation Option</h3>
                      <p>: Buyers can reserve a property with a
                        small deposit, securing their interest and kickstarting the process.
                        Helping you to sell property while you sleep. </p>
                    </li>
                    <li>
                      <h3>Dedicated Market Reach</h3>
                      <p>Be part of a specialised platform,
                        attracting those looking specifically for new developments and brand-
                        new property options.</p>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- Contact Section -->
          <div class="contact-section">
            <p>Join us to connect with motivated buyers, enhance visibility, and grow your presence in the market. Advertise with us or list your
              properties today to take your reach to the next level.</p>
            <p class="contain-title"> If you have any questions on partnering with our team, please contact us at: <a
              href="mailto:upromote@unifiproperty.com">upromote@unifiproperty.com</a>
            </p>
          </div>
        </div>
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section/>
      </el-footer>
    </el-container>
  </el-container>

</template>

<style scoped>
.mainWrapper {
  background-color: #ffffff;
  font-family: DINosaur-a, sans-serif;
  color: #003333;

}

.title-txt-wrapper{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  font-size: 18px;
}

.benefits-section {
  padding: 20px 0;

}
.benefits-section h2 {
  font-size: 22px;
  font-weight: 600;
}

.benefits-list {
  list-style: none;
  padding: 20px 0;
}

.benefits-list li {
  margin-bottom: 30px;
}


.benefits-list h3 {
  color: #003333;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 600;
}
.benefits-list p {
  font-size: 18px;
}
.benefits-image-container {
  position: relative;
}
.benefits-image-wrapper {
  width: 90%;
}

.benefits-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.features-section {
  padding: 20px 0;
  background-color: #ffffff;
  font-size: 18px;
}
.features-section h2 {
  font-size: 22px;
  font-weight: 600;
}
.features-intro {
  max-width: 90%;
  margin: 20px 0;
  text-align: left;
  line-height: 1.6;
  font-size: 18px;
}
.feature-image-container {
  position: relative;
}
.feature-image-wrapper {
  width: 90%;
}
.feature-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.feature-list {
  padding-top: 20px;
}
.feature-list h2{
  padding-top: 20px;
  font-size: 22px;
  font-weight: 600;
}

.feature-list ul {
  padding: 10px 0;
}

.feature-list li {
  margin-bottom: 20px;
  line-height: 1.6;
}
.feature-list h3 {
  font-size: 20px;
  font-weight: 600;
}
.feature-list p {
  padding-top: 10px;
  font-size: 18px;
}
.contact-section {
  text-align: left;
  padding-top: 20px;
  font-size: 18px;
}

.contact-section p {
  line-height: 1.6;
  padding-bottom: 6px;
  font-size: 18px;
}
.contact-section a {
  color: #003333;
  font-weight: 600;
}

@media (max-width: 768px) {

  .benefits-section .el-col{
    width: 100%;
  }
  .features-section .el-col {
    width: 100%;
  }

  .feature-image {
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/advertiseWithUs/advertiseWithUsLayout.vue